import React from 'react';
import { css, keyframes } from '@emotion/css';

const skeletonLoading = keyframes`
  0% {
    background-position: -200% 0;
  }
  100% {
    background-position: 200% 0;
  }
`;

const loaderStyle = css`
  background: linear-gradient(90deg, #f0f0f0 25%, #e0e0e0 50%, #f0f0f0 75%);
  background-size: 200% 100%;
  animation: ${skeletonLoading} 2s infinite;
`;

export interface GenericLoaderProps {
  width?: string;
  height?: string;
  borderRadius?: string;
  className?: string;
}

export const GenericLoader = ({
  width = '100%',
  height = '100%',
  borderRadius = '5px',
  className = '',
}: GenericLoaderProps) => {
  return (
    <div
      className={`${loaderStyle} ${className}`}
      style={{
        width,
        height,
        borderRadius,
      }}
    />
  );
};
